// ModalHistorialOficialia.tsx
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Box,
  Text,
  VStack,
  Divider,
  useDisclosure,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';

interface HistoricoOficialia {
  id: number;
  oficialiaId: number;
  remitente: string;
  dependencia: string;
  esParticular: boolean;
  correo: string;
  celular: string;
  tipoDocumento: string;
  asunto: string;
  fechaRecepcion: string;
  horaRecepcion: string;
  archivo: string | null;
  estado: string;
  motivoCancelacion: string | null;
  fechaCambio: string;
  accion: string;
}

interface Props {
  isOpen: boolean;
  onClose: () => void;
  oficialiaId: number;
}

const ModalHistorialOficialia: React.FC<Props> = ({ isOpen, onClose, oficialiaId }) => {
  const [historial, setHistorial] = useState<HistoricoOficialia[]>([]);

  useEffect(() => {
    if (isOpen && oficialiaId) {
      fetch(`https://totolac-backend.togui.com.mx/api/oficialia/${oficialiaId}/historico`)
        .then((res) => res.json())
        .then((data) => setHistorial(data))
        .catch((err) => console.error(err));
    }
  }, [isOpen, oficialiaId]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="5xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader
          bgImage="url('/img/bg.webp')"
          bgSize="cover"
          bgPosition="center"
          bgRepeat="no-repeat"
          color="white"
          textShadow="2px 2px 4px rgba(0,0,0,0.7)"
          fontWeight="bold"
          position="relative"
        >
          Historial del Registro
        </ModalHeader>
        <ModalCloseButton color="white" _hover={{ bg: 'rgba(255,255,255,0.2)' }} />
        <ModalBody>
          <VStack align="stretch" spacing={4}>
            {historial.map((item) => (
              <Box key={item.id} p={4} borderWidth="1px" borderRadius="md">
                <Text fontSize="sm" color="gray.500">Fecha de cambio: {new Date(item.fechaCambio).toLocaleString()}</Text>
                <Text fontWeight="bold" color="blue.600">Acción: {item.accion}</Text>
                <Text><strong>Remitente:</strong> {item.remitente}</Text>
                <Text><strong>Dependencia:</strong> {item.dependencia}</Text>
                <Text><strong>Correo:</strong> {item.correo}</Text>
                <Text><strong>Celular:</strong> {item.celular}</Text>
                <Text><strong>Tipo Documento:</strong> {item.tipoDocumento}</Text>
                <Text><strong>Estado:</strong> {item.estado}</Text>
                <Text><strong>Motivo Cancelación:</strong> {item.motivoCancelacion || 'N/A'}</Text>
                <Text><strong>Fecha Recepción:</strong> {new Date(item.fechaRecepcion).toLocaleString()}</Text>
                <Text><strong>Hora Recepción:</strong> {item.horaRecepcion}</Text>
                <Text><strong>Asunto:</strong> {item.asunto}</Text>

                {item.archivo && (
                  <Box mt={2}>
                    <Text fontWeight="semibold">Archivo Adjunto:</Text>
                    <iframe
                      src={`https://totolac-backend.togui.com.mx/uploads/oficialia/${item.archivo}`}
                      width="100%"
                      height="400px"
                      title={`Archivo-${item.id}`}
                    />
                  </Box>
                )}
              </Box>
            ))}
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ModalHistorialOficialia;
